enum ServiceComboEditMode {
    Create = 1,
    Edit = 2,
    View = 3
}

enum BillableServiceEditMode {
    Create = 1,
    Edit = 2
}

enum LanguageOptions {
    English = 1,
    French = 2,
    Spanish = 3
}

enum BillableServiceCountries {
    Canada = 1,
    USA = 2,
    Mexico = 3,
    Colombia = 4
}

enum BillableServiceCanadaStates {
    Quebec = 1,
    Ontario = 2,
    NewBrunswick = 3
}

enum LogIntervalType {
    Minute = 1,
    Hour = 2,
    Day = 3
}

export { BillableServiceCanadaStates, BillableServiceCountries, BillableServiceEditMode, LanguageOptions, LogIntervalType, ServiceComboEditMode };
